import { createSelector } from 'reselect';

const schemaSelector = state => state.schema.schema;

export const getSchema = createSelector(
    schemaSelector,
    schema => schema,
);
